var CONTENT_SECTIONS = [];

$(document).ready(function() {
  
  $(".content-section").each(function() {
    content_section($(this).attr('data-cs'));
  });
  
});
function content_section(csid)
{
  if(CONTENT_SECTIONS.indexOf(csid) == -1)
  {    
    CONTENT_SECTIONS.push(csid);
   	
    var container,wrapper_inner,control,item_parts,item_open,item_content,cs_type,
     wrapper = jQuery('<div/>', {class: 'content-section-wrapper'});
    $("h6." + csid).last().after(wrapper);
    cs_type = $("h6." + csid).first().attr('data-cs-type');
    
    //apply content type specific containers
    if(cs_type == "tabs")
      wrapper_inner = jQuery('<div/>', {class: 'tabs'}).appendTo(wrapper);
    else if(cs_type == "columns")
      wrapper_inner = jQuery('<div/>', {class: 'columns grid'}).appendTo(wrapper);

    $("h6." + csid).each(function(index) {            
      	if(cs_type == "accordion")
        {
          if(!$(this).hasClass("content-section-last"))
          {          
            container = jQuery('<div/>', {class: 'accordion'}).appendTo(wrapper);
            if($(this).hasClass("open"))
               control = '<h4 class="accordion-toggle open">' + $(this).text() + '<span class="icon icon-plus"></span><span class="icon icon-minus"></span></h4>';
            else
               control = '<h4 class="accordion-toggle">' + $(this).text() + '<span class="icon icon-plus"></span><span class="icon icon-minus"></span></h4>';
            $(container).append(control);

            var content_container = jQuery('<div/>', {class: 'accordion-content'}).appendTo(container);
            if(!$(this).hasClass("open"))
              $(content_container).css("display","none");

            item_content = $(this).nextUntil("h6." + csid).appendTo(content_container);
            $(container).append(content_container);
          }     
        }
        else if(cs_type == "tabs")
        {
          if(!$(this).hasClass("content-section-last"))
          {          
            if($(this).hasClass("open"))
               control = '<input type="radio" name="tabs" id="tab' + index + '" checked="checked">';
            else
               control = '<input type="radio" name="tabs" id="tab' + index + '">';
            control += '<label for="tab' + index + '">' + $(this).text() + '</label>';
            $(wrapper_inner).append(control);

            var content_container = jQuery('<div/>', {class: 'tab'}).appendTo(wrapper_inner);
            item_content = $(this).nextUntil("h6." + csid).appendTo(content_container);
            //$(container).append(content_container);
          }     
        }
      	else if(cs_type == "columns")
        {
          if(!$(this).hasClass("content-section-last"))
          {         
            if(index == 0)
              container = jQuery('<div/>', {class: 'grid__item small--one-whole medium--one-quarter medium-expand large--one-quarter'}).appendTo(wrapper_inner);
            else if(index == 1)
              container = jQuery('<div/>', {class: 'grid__item small--one-whole medium--three-quarters medium-expand large--three-quarters'}).appendTo(wrapper_inner);
            else
              return true;            
            $(wrapper_inner).append(container);
            
            control = '<h6>' + $(this).text() + '</h6>';
            $(container).append(control);
            item_content = $(this).nextUntil("h6." + csid).appendTo(container);
            $(container).append(item_content);
          }     
        }
    });
  }
}